import { Component } from '@angular/core';

@Component({
  selector: 'app-home',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent {}



// WEBPACK FOOTER //
// ./src/app/dashboard/main-dashboard/dashboard.component.ts